@if(true){
<div class="container-fluid">
    <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
        Case Transfer- (Case RefNo- {{FetchRefNo}}) <span style="color:red; text-align: right;">{{PageStatus}}</span>
        <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
            <i class="fa fa-arrow-left"></i> Back
        </button>
    </div>

    <form #TranferCase="ngForm" [formGroup]="addFormTranferCase"
        (ngSubmit)="onHeaderSubmit(TranferCase.value); clicked=true;">

        <!-- Bootstrap Accordion -->
        <div class="accordion" id="caseTransferAccordion">

            <!-- General Detail Accordion Item -->
            <div class="accordion-item mb-4">
                <h2 class="accordion-header" id="generalDetailHeading">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseGeneralDetail" aria-expanded="true"
                        aria-controls="collapseGeneralDetail">
                        <b>General Detail</b>
                    </button>
                </h2>
                <div id="collapseGeneralDetail" class="accordion-collapse collapse show"
                    aria-labelledby="generalDetailHeading" data-bs-parent="#caseTransferAccordion">
                    <div class="accordion-body p-0">
                        <div class="card pt-3">
                            <div class="card-body">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th>Field Name</th>
                                            <th>Old Data of Case</th>
                                            <th>New Data of Case</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Ref No. <span style="color:red;">*</span></td>
                                            <td>{{FetchRefNo}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <input type="text" formControlName="RefNo" class="form-control">
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Short Name</td>
                                            <td>{{FetchShortName}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <input class="form-control" formControlName="ShortName"
                                                        placeholder="Enter Short Name" name="shortname" type="text">
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Date of {{Type}}*</td>
                                            <td>{{FetchCaseDate}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <mat-form-field appearance="outline" class="fullwidth">
                                                        <input matInput [readonly]="!editable" [min]="minDate"
                                                            formControlName="DateofNotice" [max]="maxDate"
                                                            [matDatepicker]="picker" placeholder="Choose a date">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="picker"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><a routerLink="{{RouteGMAgency}}" target="_blank">Agency </a></td>
                                            <td>{{FetchAgency}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <ng-select [items]="Agency" bindLabel="MainDescr" bindValue="hdID"
                                                        formControlName="Agency" placeholder="Select Agency" appendTo="body"
                                                        [clearable]="false">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.MainDescr}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <a routerLink="{{RouteGMCategory}}" target="_blank">Category</a>/
                                                <a routerLink="{{RouteGMSubCategory}}" target="_blank">SubCategory</a>
                                            </td>
                                            <td>{{FetchCategory}}/{{FetchSubCategory}}</td>
                                            <td>
                                                <div class="col-sm-6">
                                                    <ng-select [items]="Category" bindLabel="MainDescr" bindValue="hdID"
                                                        formControlName="Category" (change)="onCategorySelect($event)"
                                                        placeholder="Select Category" [clearable]="false" appendTo="body">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.MainDescr}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                                <div class="col-sm-6">
                                                    <ng-select [items]="SubCategory" bindLabel="MainDescr"
                                                        bindValue="hdID" formControlName="SubCategory"
                                                        placeholder="Select SubCategory" [clearable]="false" appendTo="body">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.MainDescr}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <a routerLink="{{RouteCompany}}" target="_blank">Company</a>/
                                                <a routerLink="{{RouteGMDepartment}}" target="_blank">Department</a>
                                            </td>
                                            <td>{{FetchCompany}}/{{FetchDepartment}}</td>
                                            <td>
                                                <div class="col-sm-6">
                                                    <ng-select [items]="Company" bindLabel="Name" bindValue="ID"
                                                        formControlName="Company" placeholder="Select Company"
                                                        [clearable]="false" appendTo="body">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.Name}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                                <div class="col-sm-6">
                                                    <ng-select [items]="Department" bindLabel="MainDescr"
                                                        bindValue="hdID" formControlName="Department"
                                                        placeholder="Select Department" [clearable]="false" appendTo="body">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.MainDescr}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Date of Receiving</td>
                                            <td>{{FetchReceivingDate}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <mat-form-field appearance="outline" class="fullwidth">
                                                        <input matInput [readonly]="!editable" [min]="minDate"
                                                            formControlName="DateofReceiving" [max]="maxDate"
                                                            [matDatepicker]="picker1" placeholder="Choose a date">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="picker1"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker1></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Due Date</td>
                                            <td>{{FetchDueDate}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <mat-form-field appearance="outline" class="fullwidth">
                                                        <input matInput [readonly]="!editable" [min]="minDate"
                                                            formControlName="DueDate" [max]="maxDate"
                                                            [matDatepicker]="picker3" placeholder="Choose a date">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="picker3"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker3></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Court Detail Accordion Item -->
            <div class="accordion-item mb-4">
                <h2 class="accordion-header" id="courtDetailHeading">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseCourtDetail" aria-expanded="false" aria-controls="collapseCourtDetail">
                        <b>Court Detail</b>
                    </button>
                </h2>
                <div id="collapseCourtDetail" class="accordion-collapse collapse" aria-labelledby="courtDetailHeading"
                    data-bs-parent="#caseTransferAccordion">
                    <div class="accordion-body p-0">
                        <div class="card pt-3">
                            <div class="card-body">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th>Field Name</th>
                                            <th>Old Data of Case</th>
                                            <th>New Data of Case</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><a routerLink="{{RouteGMState}}" target="_blank">State</a></td>
                                            <td>{{FetchState}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <ng-select [items]="State" bindLabel="MainDescr" bindValue="hdID"
                                                        formControlName="State" (change)="onStateSelect($event)"
                                                        placeholder="Select State" [clearable]="false">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.MainDescr}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><a routerLink="{{RouteGMCity}}" target="_blank">City</a></td>
                                            <td>{{FetchCity}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <ng-select [items]="City" bindLabel="MainDescr" bindValue="hdID"
                                                        formControlName="City" (change)="onCitySelect($event)"
                                                        placeholder="Select City" [clearable]="false">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.MainDescr}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><a routerLink="{{RouteGMJurisdiction}}" target="_blank">Jurisdiction/Court
                                                    Name</a></td>
                                            <td>{{FetchJurisdiction}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <ng-select [items]="Jurisdiction" bindLabel="MainDescr" bindValue="hdID"
                                                        formControlName="Jurisdiction" placeholder="Select Jurisdiction"
                                                        [clearable]="false" appendTo="body">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.MainDescr}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Court No.</td>
                                            <td>{{FetchCourtNameNo}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <input class="form-control" formControlName="CourtName"
                                                        placeholder="Enter Court Name" name="Courtname" type="text">
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Bench No</td>
                                            <td>{{FetchBenchNo}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <input class="form-control" formControlName="BenchNo"
                                                        placeholder="Enter Bench No" name="BanchNo" type="text">
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Judge Name</td>
                                            <td>{{FetchJudgeName}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <input class="form-control" formControlName="JudgeName"
                                                        placeholder="Enter Judge Name" name="JudgeName" type="text">
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Lawyer Name</td>
                                            <td>{{FetchLawyerName}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <ng-select [items]="Lawyer" bindLabel="Name" bindValue="ContactID"
                                                        formControlName="Lawyer" placeholder="Select Lawyer"
                                                        [clearable]="false" appendTo="body">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.Name}} ({{item.State}},{{item.City}}) ({{item.Mobile}})
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Responsible Detail Accordion Item -->
            <div class="accordion-item mb-4">
                <h2 class="accordion-header" id="responsibleDetailHeading">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseResponsibleDetail" aria-expanded="false"
                        aria-controls="collapseResponsibleDetail">
                        <b>Responsible Detail</b>
                    </button>
                </h2>
                <div id="collapseResponsibleDetail" class="accordion-collapse collapse"
                    aria-labelledby="responsibleDetailHeading" data-bs-parent="#caseTransferAccordion">
                    <div class="accordion-body p-0">
                        <div class="card pt-3">
                            <div class="card-body">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th>Field Name</th>
                                            <th>Old Data of Case</th>
                                            <th>New Data of Case</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><a routerLink="{{RouteUserMaster}}" target="_blank">Manager</a></td>
                                            <td>{{FetchManager}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <ng-select [items]="Manager" bindLabel="name" bindValue="id1"
                                                        formControlName="Manager" placeholder="Select Manager"
                                                        [clearable]="false" appendTo="body">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.name}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><a routerLink="{{RouteUserMaster}}" target="_blank">Leader</a></td>
                                            <td>{{FetchLeader}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <ng-select [items]="Manager" bindLabel="name" bindValue="id1"
                                                        formControlName="Leader" placeholder="Select Leader"
                                                        [clearable]="false" appendTo="body">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.name}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Target Date</td>
                                            <td>{{FetchTargetDate}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <mat-form-field appearance="outline" class="fullwidth">
                                                        <input matInput [readonly]="!editable" [min]="minDate"
                                                            formControlName="TargetDate" [max]="maxDate"
                                                            [matDatepicker]="picker2" placeholder="Choose a date">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="picker2"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker2></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Criminal Detail Accordion Item -->
            <div class="accordion-item mb-4">
                <h2 class="accordion-header" id="criminalDetailHeading">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseCriminalDetail" aria-expanded="false"
                        aria-controls="collapseCriminalDetail">
                        <b>Criminal Detail</b>
                    </button>
                </h2>
                <div id="collapseCriminalDetail" class="accordion-collapse collapse"
                    aria-labelledby="criminalDetailHeading" data-bs-parent="#caseTransferAccordion">
                    <div class="accordion-body p-0">
                        <div class="card pt-3">
                            <div class="card-body">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th>Field Name</th>
                                            <th>Old Data of Case</th>
                                            <th>New Data of Case</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><a routerLink="{{RouteGMSection}}" target="_blank">Section</a></td>
                                            <td>{{FetchSection}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <ng-select [items]="SectionList" [clearable]="false" [multiple]="true"
                                                        formControlName="Section" bindLabel="MainDescr" [selectableGroup]="true"
                                                        [closeOnSelect]="true" bindValue="hdID" [(ngModel)]="selectedSections"
                                                        placeholder="Select Section(s)" appendTo="body">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.MainDescr}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>FIR Date</td>
                                            <td>{{FetchFIRDate}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <mat-form-field appearance="outline" class="fullwidth">
                                                        <input matInput [readonly]="!editable" [min]="minDate"
                                                            formControlName="FIRDate" [max]="maxDate" [matDatepicker]="picker5"
                                                            placeholder="Choose a FIR Date">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="picker5"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker5></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>FIR No.</td>
                                            <td>{{FetchFirNo}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <input class="form-control" formControlName="FIRNo"
                                                        placeholder="Enter FIR No" name="FIRNo" type="text">
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Police Station</td>
                                            <td>{{FetchPoliceStation}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <input class="form-control" formControlName="PoliceStation"
                                                        placeholder="Enter Police Station Name" name="Police Station"
                                                        type="text">
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Investigating Officer Name</td>
                                            <td>{{FetchInvestigationOfficer}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <input class="form-control" formControlName="InvestigatingOfficer"
                                                        placeholder="Enter Officer Name" name="OfficerName" type="text">
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Status Detail Accordion Item -->
            <div class="accordion-item mb-4">
                <h2 class="accordion-header" id="statusDetailHeading">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseStatusDetail" aria-expanded="false"
                        aria-controls="collapseStatusDetail">
                        <b>Status Detail</b>
                    </button>
                </h2>
                <div id="collapseStatusDetail" class="accordion-collapse collapse" aria-labelledby="statusDetailHeading"
                    data-bs-parent="#caseTransferAccordion">
                    <div class="accordion-body p-0">
                        <div class="card pt-3">
                            <div class="card-body">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th>Field Name</th>
                                            <th>Old Data of Case</th>
                                            <th>New Data of Case</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Seriousness</td>
                                            <td>{{FetchSeriousness}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <ng-select [items]="Seriousness" bindLabel="SubDescr" bindValue="SubID"
                                                        formControlName="Seriousness" placeholder="Select Seriousness"
                                                        [clearable]="false" appendTo="body">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.SubDescr}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            @if (this.TypeHeader == 'Notice') {
                                            <td><a routerLink="{{RouteGMNoticeStatus}}" target="_blank">Status</a></td>
                                            }
                                            @if (this.TypeHeader == 'Case') {
                                            <td><a routerLink="{{RouteGMCaseStatus}}" target="_blank">Status</a></td>
                                            }
                                            <td>{{FetchStatus}}</td>
                                            <td>
                                                <div class="col-sm-12">
                                                    <ng-select [items]="Stages" bindLabel="MainDescr" bindValue="hdID"
                                                        formControlName="Stages" placeholder="Select Status"
                                                        [clearable]="false" appendTo="body">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{item.MainDescr}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Submit Data Accordion Item -->

            @if (((Type == 'Case' && (RightsID.includes('202032001') ||
            RightsID.includes('202032021'))) ||
            (Type == 'Notice' && (RightsID.includes('202030001') ||
            RightsID.includes('202030021'))))) {
                <div class="d-flex align-items-center justify-content-center mt-3"  [hidden]="HideButtonSubmit" >
                    <button class="btn btn-primary submit-btn small" type="submit">
                      {{HeaderButtonCaption}}
                    </button>
                </div>
            }
        </div>
    </form>
</div>


} @else {
<!-- <my-content placeholder="navigation">

    <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>
    <div>&nbsp;</div>
    <div class="bg-white border border-gray-200 rounded-md px-4 py-2">
        <div class="">
            <a type="button" class="" href="/#/nav/notice/0/update">
                <i class="icon-arrow-left-circle menu-icon" title="Back" style="color: black; font-size: 20px"></i>
            </a>
        </div>
    </div>
    <div class="col-sm-12">
        <div class=" col-sm-12 lefticonD paddingless tableHeading" style="border-bottom: 1px solid #ccc;">Case Transfer-
            (Case RefNo- {{FetchRefNo}} ) <br> <span style="color:red; text-align: right;">{{PageStatus}}</span>
        </div>
        <form #TranferCase="ngForm" [formGroup]="addFormTranferCase"
            (ngSubmit)="onHeaderSubmit(TranferCase.value); clicked=true;">
            <div class="">
                <div class="col-sm-12"><br></div>
                <div class="col-sm-12">
                    <ul class="nav nav-tabs">
                        <li class="active"><a data-toggle="tab" href="#collapseCaseExpAmt"><b>General Detail</b></a>
                        </li>
                        <li><a data-toggle="tab" href="#collapseCourtDetail"><b>Court Detail</b></a></li>
                        <li><a data-toggle="tab" href="#collapseResponsibleDetail"><b>Responsible Detail</b></a></li>
                        <li><a data-toggle="tab" href="#collapseCriminalDetail"><b>Criminal Detail</b></a></li>
                        <li><a data-toggle="tab" href="#collapseStatusDetail"><b>Status Detail</b></a></li>
                        <li><a data-toggle="tab" href="#SubmitData"><b>Submit</b></a></li>
                    </ul>
                </div>

                <div class="col-sm-12 paddingles">
                    <div class="tab-content paddingles">
                        <div id="collapseCaseExpAmt" class="tab-pane fade in active">

                            <div class="col-sm-12">
                                <div class="col-sm-12">&nbsp;</div>
                                <table width="80%" class="LMtable">
                                    <tr>
                                        <th width="25%">Field Name</th>
                                        <th width="25%">Old Data of Case</th>
                                        <th width="50%">New Data of Case</th>
                                    </tr>
                                    <tr>
                                        <td>Ref No. <span style="color:red;">*</span></td>
                                        <td>{{FetchRefNo}}</td>
                                        <td>
                                            <div class="col-sm-11">
                                                <input type="text" formControlName="RefNo" class="form-control">
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Short Name</td>
                                        <td>{{FetchShortName}}</td>
                                        <td>
                                            <div class="col-sm-11"><input class="form-control"
                                                    formControlName="ShortName" placeholder="Enter Short Name"
                                                    name="shortname" type="text" value=""></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Date of {{Type}}*</td>
                                        <td>{{FetchCaseDate}}</td>
                                        <td>
                                            <div class="col-sm-11">
                                                <mat-form-field class="fullwidth">
                                                    <input matInput [readonly]="!editable" [min]="minDate"
                                                        formControlName="DateofNotice" [max]="maxDate"
                                                        [matDatepicker]="picker" placeholder="Choose a date" class="">
                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><a routerLink="{{RouteGMAgency}}" target="_blank">Agency</a></td>
                                        <td>{{FetchAgency}}</td>
                                        <td>
                                            <div class="col-sm-11"><select class="form-control"
                                                    formControlName="Agency">
                                                    <option value="0" selected>[Not Selected]</option>
                                                    <option *ngFor="let mDtl of Agency " value="{{mDtl.hdID}}">
                                                        {{mDtl.MainDescr}}</option>
                                                </select></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><a routerLink="{{RouteGMCategory}}" target="_blank">Category</a>/<a
                                                routerLink="{{RouteGMSubCategory}}" target="_blank">SubCategory</a></td>
                                        <td>{{FetchCategory}}/{{FetchSubCategory}}</td>
                                        <td>
                                            <div>
                                                <div class="col-sm-6"><select class="form-control "
                                                        formControlName="Category"
                                                        (change)="onCategorySelect($event.target.value)">
                                                        <option value="0" selected>[Not Selected]</option>
                                                        <option *ngFor="let mDtl of Category " value="{{mDtl.hdID}}">
                                                            {{mDtl.MainDescr}}</option>
                                                    </select></div>
                                                <div class="col-sm-5"><select class="form-control"
                                                        formControlName="SubCategory">
                                                        <option value="0" selected>[Not Selected]</option>
                                                        <option *ngFor="let mDtl of SubCategory " value="{{mDtl.hdID}}">
                                                            {{mDtl.MainDescr}}</option>
                                                    </select></div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><a routerLink="{{RouteCompany}}" target="_blank">Company</a>/<a
                                                routerLink="{{RouteGMDepartment}}" target="_blank">Department</a></td>
                                        <td>{{FetchCompany}}/{{FetchDepartment}}</td>
                                        <td>
                                            <div class="col-sm-6"><select class="form-control "
                                                    formControlName="Company">
                                                    <option value="0" selected>[Not Selected]</option>
                                                    <option *ngFor="let mDtl of Company" value="{{mDtl.ID}}">
                                                        {{mDtl.Name}}</option>
                                                </select></div>
                                            <div class="col-sm-5"><select class="form-control"
                                                    formControlName="Department">
                                                    <option value="0" selected>[Not Selected]</option>
                                                    <option *ngFor="let mDtl of Department " value="{{mDtl.hdID}}">
                                                        {{mDtl.MainDescr}}</option>
                                                </select></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Date of Receiving</td>
                                        <td>{{FetchReceivingDate}}</td>
                                        <td>
                                            <div class="col-sm-11">
                                                <mat-form-field class="fullwidth">
                                                    <input matInput [readonly]="!editable" [min]="minDate"
                                                        formControlName="DateofReceiving" [max]="maxDate"
                                                        [matDatepicker]="picker1" placeholder="Choose a date">
                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="picker1"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker1></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Due Date</td>
                                        <td>{{FetchDueDate}}</td>
                                        <td>
                                            <div class="col-sm-11">
                                                <mat-form-field class="fullwidth">
                                                    <input matInput [readonly]="!editable" [min]="minDate"
                                                        formControlName="DueDate" [max]="maxDate"
                                                        [matDatepicker]="picker3" placeholder="Choose a date">
                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="picker3"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker3></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </td>
                                    </tr>

                                </table>
                            </div>
                        </div>
                        <div id="collapseCourtDetail" class="tab-pane fade ">
                            <div class="col-sm-12">&nbsp;</div>
                            <table width="80%" class="LMtable">
                                <tr>
                                    <th width="25%">Field Name</th>
                                    <th width="25%">Old Data of Case</th>
                                    <th width="50%">New Data of Case</th>
                                </tr>
                                <tr>
                                    <td><a routerLink="{{RouteGMState}}" target="_blank">State</a></td>
                                    <td>{{FetchState}}</td>
                                    <td>
                                        <div class="col-sm-11"><select class="form-control " formControlName="State"
                                                (change)="onStateSelect($event.target.value)">
                                                <option value="0">[Not Selected] </option>
                                                <option *ngFor="let mDtl of State " value="{{mDtl.hdID}}">
                                                    {{mDtl.MainDescr}}</option>
                                            </select></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><a routerLink="{{RouteGMCity}}" target="_blank">City</a></td>
                                    <td>{{FetchCity}}</td>
                                    <td>
                                        <div class="col-sm-11"><select class="form-control " formControlName="City"
                                                (change)="onCitySelect($event.target.value)">
                                                <option value="0" selected>[Not Selected]</option>
                                                <option *ngFor="let mDtl of City " value="{{mDtl.hdID}}">
                                                    {{mDtl.MainDescr}}</option>
                                            </select></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><a routerLink="{{RouteGMJurisdiction}}" target="_blank">Jurisdiction/Court
                                            Name</a></td>
                                    <td>{{FetchJurisdiction}}</td>
                                    <td>
                                        <div class="col-sm-11"><select class="form-control"
                                                formControlName="Jurisdiction">
                                                <option value="0" selected>[Not Selected]</option>
                                                <option *ngFor="let mDtl of Jurisdiction " value="{{mDtl.hdID}}">
                                                    {{mDtl.MainDescr}}</option>
                                            </select></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Court No.</td>
                                    <td>{{FetchCourtNameNo}}</td>
                                    <td>
                                        <div class="col-sm-11"><input class="form-control" formControlName="CourtName"
                                                placeholder="Enter Court Name" name="Courtname" type="text" value="">
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Bench No</td>
                                    <td>{{FetchBenchNo}}</td>
                                    <td>
                                        <div class="col-sm-11"><input class="form-control" formControlName="BenchNo"
                                                placeholder="Enter Bench No" name="BanchNo" type="text" value=""></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Judge Name</td>
                                    <td>{{FetchJudgeName}}</td>
                                    <td>
                                        <div class="col-sm-11"><input class="form-control" formControlName="JudgeName"
                                                placeholder="Enter Judge Name" name="JudgeName" type="text" value="">
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Lawyer Name</td>
                                    <td>{{FetchLawyerName}}</td>
                                    <td>
                                        <div class="col-sm-11"><select class="form-control" formControlName="Lawyer">
                                                <option value="0" selected>[Not Selected]</option>
                                                <option *ngFor="let mDtl of Lawyer" value="{{mDtl.ContactID}}">
                                                    {{mDtl.Name}}&nbsp;&nbsp;&nbsp;({{mDtl.State}},{{mDtl.City}})&nbsp;&nbsp;&nbsp;({{mDtl.Mobile}}
                                                </option>
                                            </select></div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div id="collapseResponsibleDetail" class="tab-pane fade ">
                            <div class=" col-sm-12 paddingles ">
                                <div class="col-sm-12">&nbsp;</div>
                                <table width="80%" class="LMtable">
                                    <tr>
                                        <th width="25%">Field Name</th>
                                        <th width="25%">Old Data of Case</th>
                                        <th width="50%">New Data of Case</th>
                                    </tr>
                                    <tr>
                                        <td><a routerLink="{{RouteUserMaster}}" target="_blank">Manager</a></td>
                                        <td>{{FetchManager}}</td>
                                        <td>
                                            <div class="col-sm-11"><select class="form-control"
                                                    formControlName="Manager">
                                                    <option value="0" selected>[Not Selected]</option>
                                                    <option *ngFor="let mDtl of Manager " value="{{mDtl.id1}}">
                                                        {{mDtl.name}}</option>
                                                </select></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><a routerLink="{{RouteUserMaster}}" target="_blank">Leader</a></td>
                                        <td>{{FetchLeader}}</td>
                                        <td>
                                            <div class="col-sm-11"><select class="form-control"
                                                    formControlName="Leader">
                                                    <option value="0" selected>[Not Selected]</option>
                                                    <option *ngFor="let mDtl of Manager " value="{{mDtl.id1}}">
                                                        {{mDtl.name}}</option>
                                                </select></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Target Date</td>
                                        <td>{{FetchTargetDate}}</td>
                                        <td>
                                            <div class="col-sm-11">
                                                <mat-form-field class="fullwidth">
                                                    <input matInput [readonly]="!editable" [min]="minDate"
                                                        formControlName="TargetDate" [max]="maxDate"
                                                        [matDatepicker]="picker2" placeholder="Choose a date">
                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="picker2"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker2></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div id="collapseCriminalDetail" class="tab-pane fade ">
                            <div class=" col-sm-12 paddingles ">

                                <table width="80%" class="LMtable">
                                    <tr>
                                        <th width="25%">Field Name</th>
                                        <th width="25%">Old Data of Case</th>
                                        <th width="50%">New Data of Case</th>
                                    </tr>
                                    <tr>
                                        <td width="10%"><a routerLink="{{RouteGMSection}}" target="_blank">Section</a>
                                        </td>
                                        <td width="17%">{{FetchSection}}</td>
                                        <td width="24%">
                                            <div class="col-sm-11">
                                                <ng-select [items]="SectionList" [clearable]="false" [multiple]="true"
                                                    formControlName="Section" bindLabel="MainDescr"
                                                    [selectableGroup]="true" [closeOnSelect]="true" bindValue="hdID"
                                                    [(ngModel)]="selectedSections">
                                                    <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                        let-index="index">
                                                        {{item.MainDescr}}
                                                    </ng-template>
                                                </ng-select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>FIR Date</td>
                                        <td>{{FetchFIRDate}}</td>
                                        <td>
                                            <div class="col-sm-11">
                                                <mat-form-field class="fullwidth">
                                                    <input matInput [readonly]="!editable" [min]="minDate"
                                                        formControlName="FIRDate" [max]="maxDate"
                                                        [matDatepicker]="picker5" placeholder="Choose a FIR Date">
                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="picker5"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker5></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>FIR No.</td>
                                        <td>{{FetchFirNo}}</td>
                                        <td>
                                            <div class="col-sm-11"><input class="form-control" formControlName="FIRNo"
                                                    placeholder="Enter FIR No" name="FIRNo" type="text" value=""></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Police Station</td>
                                        <td>{{FetchPoliceStation}}</td>
                                        <td>
                                            <div class="col-sm-11"><input class="form-control"
                                                    formControlName="PoliceStation"
                                                    placeholder="Enter Police Station Name" name="Police Station"
                                                    type="text" value=""></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Investigating Officer Name</td>
                                        <td>{{FetchInvestigationOfficer}}</td>
                                        <td>
                                            <div class="col-sm-11"><input class="form-control"
                                                    formControlName="InvestigatingOfficer"
                                                    placeholder="Enter Officer Name" name="OfficerName" type="text"
                                                    value=""></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div id="collapseStatusDetail" class="tab-pane fade ">
                            <div class=" col-sm-12 paddingles ">

                                <table width="80%" class="LMtable">
                                    <tr>
                                        <th width="25%">Field Name</th>
                                        <th width="25%">Old Data of Case</th>
                                        <th width="50%">New Data of Case</th>
                                    </tr>
                                    <tr>
                                        <td>Seriousness</td>
                                        <td>{{FetchSeriousness}}</td>
                                        <td>
                                            <div class="col-sm-11"><select class="form-control"
                                                    formControlName="Seriousness">
                                                    <option value="0" selected>[Not Selected]</option>
                                                    <option *ngFor="let mDtl of Seriousness " value="{{mDtl.SubID}}">
                                                        {{mDtl.SubDescr}}</option>
                                                </select></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td *ngIf="this.TypeHeader=='Notice'"><a routerLink="{{RouteGMNoticeStatus}}"
                                                target="_blank">Status</a></td>
                                        <td *ngIf="this.TypeHeader=='Case'"><a routerLink="{{RouteGMCaseStatus}}"
                                                target="_blank">Status</a></td>
                                        <td>{{FetchStatus}}</td>
                                        <td>
                                            <div class="col-sm-11"><select class="form-control"
                                                    formControlName="Stages">
                                                    <option value="0" selected>[Not Selected]</option>
                                                    <option *ngFor="let mDtl of Stages " value="{{mDtl.hdID}}">
                                                        {{mDtl.MainDescr}}</option>
                                                </select></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div id="SubmitData" class="tab-pane fade ">
                            <div class=" col-sm-12 paddingles " style=" max-height: 220px;">
                                <div class="col-sm-12"><br></div>
                                <div class="col-sm-12" [hidden]="HideButtonSubmit">
                                    <div class="col-sm-5"></div>
                                    <div [hidden]="HideContent"
                                        *ngIf="(this.Type == 'Case' && this.RightsID.includes('202032001')) || (this.Type == 'Case' && this.RightsID.includes('202032021')) || (this.Type == 'Notice' && this.RightsID.includes('202030001')) || (this.Type == 'Notice' && this.RightsID.includes('202030021')) ; then HeaderButtonLink else HeaderButton">
                                    </div>
                                    <ng-template #HeaderButtonLink>
                                        <input class="btn btn-primary col-sm-2" [type]="DisplaySaveNoticeButton"
                                            value={{HeaderButtonCaption}} [disabled]="clicked">
                                    </ng-template>
                                    <ng-template #HeaderButton>
                                        <div class="col-sm-2">&nbsp;</div>
                                    </ng-template>
                                    <div class="col-sm-5"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- Tab Style END--->

                <!-- <div class="panel-group" id="HideCaseExposure">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" href="#collapseCaseExpAmt1">General Detail</a>
                        </h4>
                    </div>
                    <div id="collapseCaseExpAmt1" class="panel-collapse">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-sm col-xs">
    
                                    <table width="80%" class="LMtable">
                                            <tr>
                                                    <th width="25%">Field Name</th>
                                                    <th width="25%">Old Data of Case</th>
                                                    <th width="50%">New Data of Case</th>
                                            </tr>
                                            <tr>
                                                <td>Ref No. *</td>
                                                <td>{{FetchRefNo}}</td>
                                                <td>
                                                    <div class="col-sm-11">
                                                        <input type="text" formControlName="RefNo" class="form-control">
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                    <td>Short Name</td>
                                                    <td>{{FetchShortName}}</td>
                                                    <td>
                                                        <div class="col-sm-11"><input class="form-control" formControlName="ShortName" placeholder="Enter Short Name" name="shortname" type="text" value=""></div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>Date of {{Type}}*</td>
                                                    <td>{{FetchCaseDate}}</td>
                                                    <td>
                                                        <div class="col-sm-11">
                                                            <mat-form-field class="fullwidth">
                                                                <input matInput [readonly]="!editable" [min]="minDate" formControlName="DateofNotice" [max]="maxDate" [matDatepicker]="picker" placeholder="Choose a date" class="">
                                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                                <mat-datepicker #picker></mat-datepicker>
                                                            </mat-form-field>
                                                        </div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                <td><a routerLink="{{RouteGMAgency}}" target="_blank">Agency</a></td>
                                                <td>{{FetchAgency}}</td>
                                                <td>
                                                        <div class="col-sm-11"><select class="form-control" formControlName="Agency"> <option value="0" selected>[Not Selected]</option><option *ngFor="let mDtl of Agency " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}</option> </select></div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><a routerLink="{{RouteGMCategory}}" target="_blank">Category</a>/<a routerLink="{{RouteGMSubCategory}}" target="_blank">SubCategory</a></td>
                                                <td>{{FetchCategory}}/{{FetchSubCategory}}</td>
                                                <td>
                                                        <div>
                                                            <div class="col-sm-6"><select class="form-control " formControlName="Category" (change)="onCategorySelect($event.target.value)"><option value="0" selected>[Not Selected]</option> <option *ngFor="let mDtl of Category " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}</option></select></div>
                                                            <div class="col-sm-5"><select class="form-control" formControlName="SubCategory"> <option value="0" selected>[Not Selected]</option><option *ngFor="let mDtl of SubCategory " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}</option> </select></div>
                                                        </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                    <td><a routerLink="{{RouteCompany}}" target="_blank">Company</a>/<a routerLink="{{RouteGMDepartment}}" target="_blank">Department</a></td>
                                                    <td>{{FetchCompany}}/{{FetchDepartment}}</td>
                                                    <td>
                                                        <div class="col-sm-6"><select class="form-control " formControlName="Company"><option value="0" selected>[Not Selected]</option> <option *ngFor="let mDtl of Company" value = "{{mDtl.ID}}">{{mDtl.Name}}</option></select></div>
                                                        <div class="col-sm-5"><select class="form-control" formControlName="Department"> <option value="0" selected>[Not Selected]</option><option *ngFor="let mDtl of Department " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}</option> </select></div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>Date of Receiving</td>
                                                    <td>{{FetchReceivingDate}}</td>
                                                    <td>
                                                        <div class="col-sm-11">
                                                            <mat-form-field class="fullwidth">
                                                               <input matInput [readonly]="!editable" [min]="minDate" formControlName="DateofReceiving" [max]="maxDate" [matDatepicker]="picker1" placeholder="Choose a date">
                                                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                                                <mat-datepicker #picker1></mat-datepicker>
                                                            </mat-form-field>
                                                        </div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>Due Date</td>
                                                    <td>{{FetchDueDate}}</td>
                                                    <td>
                                                        <div class="col-sm-11">
                                                            <mat-form-field class="fullwidth">
                                                                <input matInput [readonly]="!editable" [min]="minDate" formControlName="DueDate" [max]="maxDate" [matDatepicker]="picker3" placeholder="Choose a date">
                                                                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                                                <mat-datepicker #picker3></mat-datepicker>
                                                            </mat-form-field>
                                                        </div>
                                                    </td>
                                            </tr>
    
                                    </table>
                                </div>
    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        <div class="panel-group" id="HideCaseExposure">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" href="#collapseCourtDetail1">Court Detail</a>
                        </h4>
                    </div>
                    <div id="collapseCourtDetail1" class="panel-collapse collapse">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-sm col-xs">
                                    <table width="80%" class="LMtable">
                                            <tr>
                                                    <th width="25%">Field Name</th>
                                                    <th width="25%">Old Data of Case</th>
                                                    <th width="50%">New Data of Case</th>
                                            </tr>
                                            <tr>
                                                    <td><a routerLink="{{RouteGMState}}" target="_blank">State</a></td>
                                                    <td>{{FetchState}}</td>
                                                    <td>
                                                        <div class="col-sm-11"><select class="form-control " formControlName="State" (change)="onStateSelect($event.target.value)"><option value="0">[Not Selected] </option> <option *ngFor="let mDtl of State " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}</option></select></div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td><a routerLink="{{RouteGMCity}}" target="_blank">City</a></td>
                                                    <td>{{FetchCity}}</td>
                                                    <td>
                                                     <div class="col-sm-11"><select class="form-control " formControlName="City" (change)="onCitySelect($event.target.value)"><option value="0" selected>[Not Selected]</option> <option *ngFor="let mDtl of City " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}</option></select></div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td><a routerLink="{{RouteGMJurisdiction}}" target="_blank">Jurisdiction</a></td>
                                                    <td>{{FetchJurisdiction}}</td>
                                                    <td>
                                                    <div class="col-sm-11"><select class="form-control" formControlName="Jurisdiction"> <option value="0" selected>[Not Selected]</option><option *ngFor="let mDtl of Jurisdiction " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}</option> </select></div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>Court Name/No.</td>
                                                    <td>{{FetchCourtNameNo}}</td>
                                                    <td>
                                                        <div class="col-sm-11"><input class="form-control" formControlName="CourtName" placeholder="Enter Court Name" name="Courtname" type="text" value=""></div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>Bench No</td>
                                                    <td>{{FetchBenchNo}}</td>
                                                    <td>
                                                        <div class="col-sm-11"><input class="form-control" formControlName="BenchNo" placeholder="Enter Bench No" name="BanchNo" type="text" value=""></div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>Judge Name</td>
                                                    <td>{{FetchJudgeName}}</td>
                                                    <td>
                                                        <div class="col-sm-11"><input class="form-control" formControlName="JudgeName" placeholder="Enter Judge Name" name="JudgeName" type="text" value=""></div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>Lawyer Name</td>
                                                    <td>{{FetchLawyerName}}</td>
                                                    <td>
                                                            <div class="col-sm-11"><select class="form-control" formControlName="Lawyer"> <option value="0" selected>[Not Selected]</option><option *ngFor="let mDtl of Lawyer" value="{{mDtl.ContactID}}">{{mDtl.Name}}&nbsp;&nbsp;&nbsp;({{mDtl.State}},{{mDtl.City}})&nbsp;&nbsp;&nbsp;({{mDtl.Mobile}}</option> </select></div>
                                                    </td>
                                            </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        <div class="panel-group" id="HideCaseExposure">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" href="#collapseResponsibleDetail1">Responsible Detail</a>
                        </h4>
                    </div>
                    <div id="collapseResponsibleDetail1" class="panel-collapse collapse">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-sm col-xs">
                                    <table width="80%" class="LMtable">
                                            <tr>
                                                    <th width="25%">Field Name</th>
                                                    <th width="25%">Old Data of Case</th>
                                                    <th width="50%">New Data of Case</th>
                                            </tr>
                                            <tr>
                                                    <td><a routerLink="{{RouteUserMaster}}" target="_blank">Manager</a></td>
                                                    <td>{{FetchManager}}</td>
                                                    <td>
                                                        <div class="col-sm-11"><select class="form-control" formControlName="Manager"> <option value="0" selected>[Not Selected]</option><option *ngFor="let mDtl of Manager " value="{{mDtl.id1}}">{{mDtl.name}}</option> </select></div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                <td><a routerLink="{{RouteUserMaster}}" target="_blank">Leader</a></td>
                                                <td>{{FetchLeader}}</td>
                                                <td>
                                                    <div class="col-sm-11"><select class="form-control" formControlName="Leader"> <option value="0" selected>[Not Selected]</option><option *ngFor="let mDtl of Manager " value="{{mDtl.id1}}">{{mDtl.name}}</option> </select></div>
                                                </td>
                                            </tr>
                                            <tr>
                                                    <td>Target Date</td>
                                                    <td>{{FetchTargetDate}}</td>
                                                    <td>
                                                        <div class="col-sm-11">
                                                            <mat-form-field class="fullwidth">
                                                               <input matInput [readonly]="!editable" [min]="minDate" formControlName="TargetDate" [max]="maxDate" [matDatepicker]="picker2" placeholder="Choose a date">
                                                                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                                                <mat-datepicker #picker2></mat-datepicker>
                                                            </mat-form-field>
                                                        </div>
                                                    </td>
                                            </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        <div class="panel-group" id="HideCaseExposure">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" href="#collapseCriminalDetail1">Criminal Detail</a>
                        </h4>
                    </div>
                    <div id="collapseCriminalDetail1" class="panel-collapse collapse">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-sm col-xs">
                                    <table width="80%" class="LMtable">
                                            <tr>
                                                    <th width="25%">Field Name</th>
                                                    <th width="25%">Old Data of Case</th>
                                                    <th width="50%">New Data of Case</th>
                                            </tr>
                                            <tr>
                                                <td width="10%"><a routerLink="{{RouteGMSection}}" target="_blank">Section</a></td>
                                                <td width="17%">{{FetchSection}}</td>
                                                <td width="24%">
                                                    <div class="col-sm-11">
                                                    <ng-select [items]="SectionList" [clearable]="false" [multiple]="true" formControlName="Section" bindLabel="MainDescr" [selectableGroup]="true" [closeOnSelect]="true" bindValue="hdID" [(ngModel)]="selectedSections">
                                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                                        {{item.MainDescr}}
                                                    </ng-template>
                                                    </ng-select>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                    <td>FIR Date</td>
                                                    <td>{{FetchFIRDate}}</td>
                                                    <td>
                                                        <div class="col-sm-11">
                                                            <mat-form-field class="fullwidth">
                                                                <input matInput [readonly]="!editable" [min]="minDate" formControlName="FIRDate" [max]="maxDate" [matDatepicker]="picker5" placeholder="Choose a FIR Date">
                                                                <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                                                                <mat-datepicker #picker5></mat-datepicker>
                                                            </mat-form-field>
                                                        </div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>FIR No.</td>
                                                    <td>{{FetchFirNo}}</td>
                                                    <td>
                                                        <div class="col-sm-11"><input class="form-control" formControlName="FIRNo" placeholder="Enter FIR No" name="FIRNo" type="text" value=""></div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>Police Station</td>
                                                    <td>{{FetchPoliceStation}}</td>
                                                    <td>
                                                        <div class="col-sm-11"><input class="form-control" formControlName="PoliceStation" placeholder="Enter Police Station Name" name="Police Station" type="text" value=""></div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>Investigating Officer Name</td>
                                                    <td>{{FetchInvestigationOfficer}}</td>
                                                    <td>
                                                        <div class="col-sm-11"><input class="form-control" formControlName="InvestigatingOfficer" placeholder="Enter Officer Name" name="OfficerName" type="text" value=""></div>
                                                    </td>
                                            </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        <div class="panel-group" id="HideCaseExposure">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" href="#collapseStatusDetail1">Case Status Detail</a>
                        </h4>
                    </div>
                    <div id="collapseStatusDetail1" class="panel-collapse collapse">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-sm col-xs">
                                    <table width="80%" class="LMtable">
                                            <tr>
                                                    <th width="25%">Field Name</th>
                                                    <th width="25%">Old Data of Case</th>
                                                    <th width="50%">New Data of Case</th>
                                            </tr>
                                            <tr>
                                                    <td>Seriousness</td>
                                                    <td>{{FetchSeriousness}}</td>
                                                    <td>
                                                        <div class="col-sm-11"><select class="form-control" formControlName="Seriousness"> <option value="0" selected>[Not Selected]</option><option *ngFor="let mDtl of Seriousness " value="{{mDtl.SubID}}">{{mDtl.SubDescr}}</option> </select></div>
                                                    </td>
                                            </tr>
                                            <tr>
    
                                                    <td ><a routerLink="{{RouteGMCaseStatus}}" target="_blank">Status</a></td>
                                                    <td>{{FetchStatus}}</td>
                                                    <td>
                                                        <div class="col-sm-11"><select class="form-control" formControlName="Stages"> <option value="0" selected>[Not Selected]</option><option *ngFor="let mDtl of Stages " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}</option> </select></div>
                                                    </td>
                                            </tr>
                                    </table>
                                    <div class="col-sm-12">&nbsp;</div>
    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

                <!-- <table style="display:none;" width="100%" class="LMtable_lite entry">
                    <tr>
                        <td width="10%">{{Type}} *</td>
                        <td width="16%">{{FetchCaseType}}</td>
                        <td width="23%">
                            <div class="col-sm-11"><label class="radio-inline"><input type="radio"
                                        formControlName="Notice" value="1">{{Sent}}</label>
                                <label class="radio-inline"><input type="radio" formControlName="Notice"
                                        value="0">{{Received}}</label>
                            </div>
                        </td>


                    </tr>
                    <tr>
                        <td>Last Date to Respond</td>
                        <td>{{FetchLastDateRespond}}</td>
                        <td>
                            <div class="col-sm-11">
                                <mat-form-field class="fullwidth">
                                    <input matInput [readonly]="!editable" [min]="minDate" formControlName="LastDate"
                                        [max]="maxDate" [matDatepicker]="picker4" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                    <mat-datepicker #picker4></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </td>
                        <td><a routerLink="{{RouteGMCurrency}}" target="_blank">Currency</a></td>
                        <td>{{FetchCurrency}}</td>
                        <td>
                            <div class="col-sm-11"><select class="form-control" formControlName="Currency">
                                    <option value="0" selected>[Not Selected]</option>
                                    <option *ngFor="let mDtl of Currency" value="{{mDtl.hdID}}">{{mDtl.MainDescr}}
                                    </option>
                                </select></div>
                        </td>
                    </tr>
                    <tr>

                        <td>Exposure Amount</td>
                        <td>{{FetchExposureAmount}}</td>
                        <td>
                            <div class="col-sm-11"><input class="form-control" formControlName="ExposureAmmount"
                                    placeholder="Enter Exposure Amount" step="0.01" name="exposureamount" type="number"
                                    value=""></div>
                        </td>

                        <td>Recovery Amount</td>
                        <td>{{FetchRecoveryAmount}}</td>
                        <td>
                            <div class="col-sm-11"><input class="form-control" formControlName="RecoveryAmount"
                                    placeholder="Enter Recovery Amount" name="Recoveryamount" type="number" value="">
                            </div>
                        </td>
                    </tr>
                    <tr>

                        <td>Negotiation Amount</td>
                        <td>{{FetchNegotiationAmount}}</td>
                        <td>
                            <div class="col-sm-11"><input class="form-control" formControlName="NegotiationAmount"
                                    placeholder="Enter Nagotiation Amount" name="negotiationamount" type="number"
                                    value=""></div>
                        </td>
                        <td>Balance Amount</td>
                        <td>{{FetchBalanceAmount}}</td>
                        <td>
                            <div class="col-sm-11"><input class="form-control" formControlName="BalanceAmount"
                                    placeholder="Enter Balance Amount" name="balanceamount" type="number" value="">
                            </div>
                        </td>
                    </tr>


                </table>

                <div col-sm-12>&nbsp;</div>
            </div>
            <div class="form-group mt-2" style="display:none;">
                <div class="form-check">
                    <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true
                        [(ngModel)]="options.autoClose">
                    <label for="autoClose">Auto close alert after three seconds</label>
                </div>

            </div>
        </form>

    </div>

</my-content>
<my-content placeholder="main">

</my-content> -->
}